import { Validators } from '@angular/forms';
import {
    nonNegativeWholeNumberValidator,
    numberValidator,
    postcodeValidator
} from '@app/shared/validators/reactive-form-validators';
import { LOT_MIGRATOR_MAX_LENGTHS } from './lot-migrator-max-lengths';

export const buildLotMigratorAddressControls = () => ({
    LotNumber: ['', [Validators.required, nonNegativeWholeNumberValidator()]],
    DpNumber: ['', [Validators.maxLength(LOT_MIGRATOR_MAX_LENGTHS.dpNumber)]],
    Street: [
        '',
        [Validators.required, Validators.maxLength(LOT_MIGRATOR_MAX_LENGTHS.street)]
    ],
    Suburb: [
        '',
        [Validators.required, Validators.maxLength(LOT_MIGRATOR_MAX_LENGTHS.suburb)]
    ],
    City: ['', [Validators.required, Validators.maxLength(LOT_MIGRATOR_MAX_LENGTHS.city)]],
    PostCode: ['', [postcodeValidator()]],
    AddressRegion: ['', Validators.required]
});

export const buildLotMigratorLotBuildControls = (lotType: string) => ({
    LotContractType: ['', Validators.required],
    LotType: [lotType],
    LotBuildType: ['', Validators.required]
});

export const buildLotMigratorAreaControls = () => ({
    FloorArea: [null, [numberValidator(), Validators.min(0)]],
    LandArea: [null, [numberValidator(), Validators.min(0)]]
});

export const buildLotMigratorPricingControls = () => ({
    PriceLand: [null, [numberValidator(), Validators.min(0)]],
    PriceSell: [null, [numberValidator(), Validators.min(0)]]
});

export const buildLotMigratorRoomsAndParkingControls = () => ({
    NoBedrooms: [null, [nonNegativeWholeNumberValidator()]],
    NoBathrooms: [null, [nonNegativeWholeNumberValidator()]],
    NoLivingRooms: [null, [nonNegativeWholeNumberValidator()]],
    NoGarages: [null, [numberValidator(), Validators.min(0)]],
    NoCarparks: [null, [nonNegativeWholeNumberValidator()]],
    NoStudy: [null, [nonNegativeWholeNumberValidator()]]
});

export const buildLotMigratorBuildTypeLinkControl = (isUnit: boolean) => ({
    BuildTypeLink: [
        '',
        isUnit ? [Validators.required, nonNegativeWholeNumberValidator()] : []
    ]
});
